import _ from 'lodash';

const CheckForDirtyUtility = (model) => {
  // init the utility with the "model" containing original clean data
  return {
    test: (e, currentState) => {
      // run test with the current data state
      // returns true if differences are found
      // returns false if still clean
      const differences = [];
      Object.keys(model).forEach(key => {
        if (model[key] !== null && typeof model[key] === 'object' && !Array.isArray(model[key])) {
          // object or null -- String([1,2,3] will flatten the array into a string)
          const obj1 = {
            ...model[key],
            dirty: false, // should not keep dirty check inside data object. reset here for cases where that occurs.
          };
          const obj2 = {
            ...currentState[key],
            dirty: false,
          }
          if (!_.isEqual(obj1, obj2)) {
            // console.info('FOUND DIFF in', key);
            // console.info('obj1', obj1);
            // console.info('obj2', obj2);
            differences.push(key);
          }
        } else if (Array.isArray(model[key])) {
          model[key].forEach((item, i) => {
            if (typeof item === 'object' && item !== null && !Array.isArray(item)) {
              // console.info('OBJECT IN ARRAY!', item, currentState[key][i]);
              if (!_.isEqual(model[key], currentState[key])) {
                differences.push(key);
              }
            } else if (String(item) !== String(currentState[key][i])) {
              differences.push(key);
            }
          });
        } else if (String(model[key]) !== String(currentState[key])) {
          differences.push(key);
        }
      });
      if (differences.length) {
        // console.info('FORM IS DIRTY!');
        // console.info(differences.map(key => `${key}: ${model[key]} (${typeof model[key]}) !== ${currentState[key]} (${typeof currentState[key]})`).join(', '));
        return true;
      }
      return false;
    },
  };
};

export default CheckForDirtyUtility;



// WEBPACK FOOTER //
// ./src/utilities/checkForDirty.js